module.exports = __webpack_public_path__ + "img/gallery.3fbe2149.jpg";